import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { MissionDetailForAuthorizedUser } from '@/features/missions/MissionsWrappers'
import { useParams } from 'react-router-dom'

const MissionDetailWebviewPage = () => {
  const { id } = useParams<{ id: string }>()
  if (!id) return null
  return (
    <MissionsUrlProvider isWebview={true}>
      <div className="px-4 py-4">
        <MissionDetailForAuthorizedUser missionId={id} />
      </div>
    </MissionsUrlProvider>
  )
}

export default MissionDetailWebviewPage
